import React, { useContext } from 'react'
import classNames from 'classnames'
import { useNavContext } from '../useNavContext'
import { I18nextContext } from '@toasttab/shared/src/context/i18nextContext'
import { localizeLink } from '@toasttab/shared/src/utils/linkUtils'
import { MenuProps } from '../ContentfulNavigation.d'

const MobileParentMenu = ({
  dropdownContent,
  heapClass,
  linkUrl,
  title
}: MenuProps) => {
  const { selectedParentMenu, setIsRegionMenuOpen, setSelectedParentMenu } =
    useNavContext()
  const localizationContext = useContext(I18nextContext)

  const handleClick = (title: string) => {
    setIsRegionMenuOpen(false)
    setSelectedParentMenu(title !== selectedParentMenu ? title : null)
  }
  const isExpanded = title === selectedParentMenu
  const subMenuCss = classNames(
    'hover:bg-gray-25 focus:bg-gray-25 border-b border-b-gray-25 border-r-4 border-r-transparent hover:border-r-blue-75 focus:border-r-blue-75',
    {
      'bg-gray-25 !border-r-blue-75': isExpanded
    }
  )
  const openButtonCss = classNames(
    'relative flex items-center justify-between text-left w-full p-4 h-[80px]',
    heapClass,
    {
      'after:content-icon-chevron-right': !isExpanded
    }
  )
  if (dropdownContent?.subMenus) {
    return (
      <div
        className={subMenuCss}
        data-testid='MobileParentMenu'
        key={`mobile-parent-menu-${title}}`}
        role='none'
      >
        <button
          aria-controls={`${title.replace(/\s/g, '-')}-mobile-menu`}
          aria-expanded={isExpanded}
          aria-haspopup='true'
          className={openButtonCss}
          onClick={() => handleClick(title)}
          role='menuitem'
        >
          <h4 className='font-effra text-default text-[22px] leading-8 '>
            {title}
          </h4>
        </button>
      </div>
    )
  } else {
    const menuHref = localizeLink(
      linkUrl,
      localizationContext.language,
      localizationContext
    )
    return (
      <div
        className='hover:bg-gray-25 focus:bg-gray-25 p-4 border-b border-b-gray-25 border-r-4 border-r-transparent hover:border-r-blue-75 focus:border-r-blue-75'
        key={`mobile-parent-link-${title}}`}
        role='none'
      >
        <a
          className={`${heapClass} relative flex items-center justify-between text-left w-full h-[64px]`}
          href={menuHref}
          role='menuitem'
        >
          <h4 className='font-effra text-default text-[22px] leading-8 py-4'>
            {title}
          </h4>
        </a>
      </div>
    )
  }
}

export default MobileParentMenu
